// Shared chart palette used across NPH graph components so colors are
// consistent regardless of which slice/bar appears first.
// Order is intentional — first color renders for the first data slice.
export const CHART_PALETTE = [
    '#5e72e4', // primary blue
    '#11cdef', // cyan
    '#2dce89', // green
    '#fb6340', // orange
    '#f5365c', // red
    '#ffd600', // yellow
    '#8965e0', // purple
    '#f3a4b5', // pink
    '#172b4d', // dark slate
    '#adb5bd'  // neutral gray
]

// Reserved color for "uncategorised" buckets (Untyped / No Size / Other)
export const UNCATEGORISED_COLOR = '#adb5bd'

// Pick a color for an item by its index in the active dataset.
// Wraps if there are more items than palette entries.
export function paletteColor(index) {
    return CHART_PALETTE[index % CHART_PALETTE.length]
}
